import React from "react";
import HDFC from "../../images/afs6y3wslv253xfuqeqx.webp";
import SBI from "../../images/dqrmu457oumzsrzni79f.webp";
import Kotak from "../../images/j7fnnakxrufltxc8p2wl.webp";
import ICICI from "../../images/md9c78nywstkun7ffqzm.webp";
import Image1 from "../../images/sce51c0fso0enxcf0jup.webp"
import Image2 from "../../images/tbafylka6qnkddfz3tim.webp"
import Image3 from "../../images/u0q2g2knl3ep0yhj02ce.webp"




export default function BankingPartners() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-10">
      <h4 className="text-2xl md:text-4xl font-bold text-center mb-4">
        Our Banking Partners
      </h4>
      <p className="text-center text-gray-600 max-w-xl mx-auto mb-8">
        Partnering with leading banks, we offer affordable home loan options to help you build your dream home within your budget.
      </p>

      <div className="flex flex-wrap justify-center items-center gap-8">
        <img
          src={HDFC}
          alt="HDFC Bank" title="HDFC Bank"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
        <img
          src={SBI}
          alt="SBI" title="SBI"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
        <img
          src={Kotak}
          alt="Kotak" title="Kotak"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
        <img
          src={ICICI}
          alt="ICICI Bank" title="ICICI Bank"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
         <img
          src={Image1}
          alt="ICICI Bank" title="ICICI Bank"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
         <img
          src={Image2}
          alt="ICICI Bank" title="ICICI Bank"
          className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300"
         loading="lazy"/>
  
      </div>
    </section>
  );
}
